module.exports = {
      id: "whatsapp-usage",
      viewBox: "0 0 38.254 38.254",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }